import { Header } from '../../../../../components/DataTable'

export const headers: Header[] = [
  { name: 'Tipo', field: 'type', sortable: true, custom: true },
  { name: 'Título', field: 'title', sortable: true },
  {
    name: 'Informações finais',
    field: 'is_final_process_information',
    sortable: true,
    custom: true
  },
  { name: 'Url', field: 'url', sortable: true },
  { name: 'Criado em', field: 'created_at', sortable: true, custom: true },
  {
    name: 'Ações',
    field: 'actions',
    sortable: false
  }
]
